<template>
    <div v-if="!closed" class="youtube-popup">
        <div class="youtube-popup__inner">
            <button @click.prevent="closePopup()" class="inner__close-popup">
                <img
                    src="@/assets/images/popup-close.svg"
                    alt="Zamknij odtwarzacz video"
                />
            </button>
            <a v-if="auction_url" class="inner__auction-link" target="_blank" :href="auction_url">Licytuj</a>
            <div class="youtube-wrapper">
                <iframe
                    width="560"
                    height="315"
                    :src="
                        'https://www.youtube.com/embed/' +
                            youtube_id +
                            '?autoplay=1&start=538'
                    "
                    frameborder="0"
                    allow="accelerometer; autoplay; gyroscope;"
                    allowfullscreen
                ></iframe>
            </div>
        </div>
        <!-- <Portal v-if="inactive" to="video-player">
            <div></div>
        </Portal> -->
    </div>
</template>

<script>
export default {
    props: ["youtube_id", "closed", "auction_url"],
    methods: {
        closePopup: function() {
            this.$emit("closePlayer", true);
        }
    }
};
</script>

<style lang="scss">
@import "@/scss/_general.scss";

.youtube-popup {
    position: fixed;
    z-index: 102;
    width: 100vw;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);

    .youtube-popup__inner {
        width: 80%;
        position: relative;
        margin: 40px auto 0;

        @media only screen and (max-width: 768px) {
            width: 100%;
        }

        a.inner__auction-link {
            position: absolute;
            background: $orange1;
            z-index: 102;
            left: 50%;
            bottom: 10%;
            color: #fff;
            padding: 20px 35px;
            border-radius: 2px;
            font-size: 19px;
            letter-spacing: 2px;
            text-transform: uppercase;
            text-decoration: none;

            -webkit-transform: translateX(-50%);
            -moz-transform: translateX(-50%);
            -ms-transform: translateX(-50%);
            -o-transform: translateX(-50%);
            transform: translateX(-50%);

            @media only screen and (max-width: 991px) {
                bottom: -80px;
            }

            @media only screen and (max-width: 768px) {
                left: 24px;
                transform: none;
            }
        }

        .inner__close-popup {
            position: absolute;
            top: 80px;
            right: 30px;
            z-index: 102;
            background: $orange1;
            border: 0;
            border-radius: 99px;
            width: 73px;
            height: 73px;

            &:hover {
                background: darken($orange1, 5%);
            }

            @media only screen and (max-width: 991px) {
                top: initial;
                bottom: -85px;
            }

            @media only screen and (max-width: 768px) {
                right: 24px;
            }
        }

        .youtube-wrapper {
            width: 100%;
            position: relative;
            padding-bottom: 56.25%; /* 16:9 */
            padding-top: 25px;
            height: 0;
        }
        .youtube-wrapper iframe {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;

            .ytp-show-cards-title {
                display: none;
            }
        }
    }
}
</style>
